module.exports = __webpack_public_path__ + "img/welcome-updated.37c31f17.webp";